import React, { useState } from "react";
import cls from "classnames";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    overflowY: "auto"
  },
  fade: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background:
      "linear-gradient(to top, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)",
    pointerEvents: "none",
    zIndex: 1
  }
}));

const FadedContainer = ({
  children,
  Component,
  className,
  fadeHeight,
  containerSize,
  ...props
}) => {
  const classes = useStyles();
  const [currentFadeHeight, setCurrentFadeHeight] = useState(0);
  const ref = React.useRef(null);

  function getFadeHeight() {
    const scrollAmount = ref.current.scrollHeight - ref.current.offsetHeight;
    const scrollBottom = scrollAmount - ref.current.scrollTop;
    return Math.min(scrollBottom, fadeHeight);
  }

  const handleScroll = ev => {
    setCurrentFadeHeight(getFadeHeight());
  };

  React.useEffect(() => {
    setCurrentFadeHeight(getFadeHeight());
  }, [containerSize]);

  return Component ? (
    <Component
      {...props}
      className={cls(className, classes.root)}
      onScroll={handleScroll}
    >
      {children}
      <div
        className={classes.fade}
        style={{
          height: currentFadeHeight + "px"
        }}
      />
    </Component>
  ) : (
    <div className={classes.root} onScroll={handleScroll} ref={ref}>
      {children}
      <div
        ref={ref}
        className={classes.fade}
        style={{
          height: currentFadeHeight + "px"
        }}
      />
    </div>
  );
};

export default FadedContainer;
